<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog :title="title" :visible.sync="showDialog" :modal-append-to-body=false width="1100px" v-dialog-drag
      :destroy-on-close="true" :modal=false :before-close="cancel">
      <el-form class="formDiv" label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="合同编号" prop="contractId" v-if="selectType.type === 'add'">
         <el-select v-model="form.contractId" filterable :disabled="contractId && contractId.length > 0"
            @change="changeContract" multiple placeholder="请输入合同编号" style="width: 330px;" remote
            :loading="contractLoading" :remote-method="remoteMethod" reserve-keyword>
            <el-option v-for="item in contractOption" :key="item.id"
              :label="item.contractNumber + '-' + item.contractName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <div style="width: 100%;margin-bottom: 20px;text-align: center;">
          <el-table :fit="false" style="width: 917px;display: inline-block" border
            :data="!isRecord?tableData:tableData.slice(0, -1)">
            <el-table-column label="邮寄说明" width="90" prop="name"></el-table-column>
            <el-table-column label="是否邮寄" width="88" align="center">
              <template slot-scope="scope">
                <el-form-item label-width="0" :prop="'mailingContent.' + scope.row.mailProp" v-if="scope.row.mailProp"
                  style="width: 100%!important;margin-bottom: 0"
                  :rules="{required: true, message: scope.row.mailMessage, trigger: 'change'}">
                  <el-select style="width: 100%" v-model="form.mailingContent[scope.row.mailProp]"
                    @change="(value) => changeMailNumber(value,scope.row.type)" class="no-border-select"
                    :placeholder=scope.row.mailMessage>
                    <el-option v-for="item in numberOption.slice(scope.row.min,scope.row.max)" :key="item.value"
                      :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <span v-else>{{'NA'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否扫描" width="88" align="center">
              <template slot-scope="scope">
                <el-form-item label-width="0" :prop="'mailingContent.' + scope.row.scanningProp"
                  v-if="scope.row.scanningProp" style="width: 100%!important;margin-bottom: 0"
                  :rules="{required: true, message: scope.row.scanningMessage, trigger: 'change'}">
                  <el-select style="width: 100%" v-model="form.mailingContent[scope.row.scanningProp]"
                    @change="(value) => changeMailNumber(value,scope.row.type)" class="no-border-select"
                    :placeholder=scope.row.scanningMessage>
                    <el-option v-for="item in flagOption" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <span v-else>{{'NA'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="上传文件" width="350" align="center">
              <template slot-scope="scope">
                <el-form-item style="width: 100%!important;margin-bottom: 0" label-width="0" v-if="scope.row.file">
                  <div style="display: flex; align-items: center; width: 100%;">
                    <div style="width: 86%!important;">
                      <div style="width: 100%!important;margin-bottom: 2px;" v-if="$data[scope.row.fileList].length > 0"
                        v-for="(fileItem, fileIndex) in $data[scope.row.fileList]">
                        <div style="display: flex;width: 100%!important;">
                          <el-input v-model="fileItem.name" readonly style="margin-right: 5px;"></el-input>
                          <div>
                            <el-button type="danger" icon="el-icon-delete" size="small"
                              @click="handleRemove([fileIndex], scope.row.type)"></el-button>
                          </div>
                        </div>
                      </div>
                      <div v-if="$data[scope.row.fileList].length <= 0" style="display: flex;width: 100%!important;">
                        <el-input v-if="$data[scope.row.fileList].length <= 0" v-model="$data[scope.row.fileName]"
                          style="margin-right: 5px;" readonly></el-input>
                        <div>
                          <el-button type="danger" icon="el-icon-delete" size="small"></el-button>
                        </div>
                      </div>
                    </div>

                    <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false" :limit="5"
                      :on-change="(...event) => { handleChange(event, scope.row.type) }" :multiple="true"
                      style="width: 5%!important;margin-left: 5px" :file-list="$data[scope.row.fileList]"
                      :on-exceed="handleExceed">
                      <el-button type="primary" icon="el-icon-plus" size="small"></el-button>
                    </el-upload>

                  </div>
                </el-form-item>
                <span v-else>{{'NA'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="备注" width="300" align="center">
              <template slot-scope="scope">
                <el-form-item label-width="0" style="width: 100%!important;margin-bottom: 0"
                  :prop="'mailingContent.' + scope.row.remark" v-if="scope.row.remark">
                  <el-input v-model="form.mailingContent[scope.row.remark]" auto-complete="off" class="no-border-select"
                    type="textarea" :autosize="{ minRows: 1}" show-word-limit maxlength="300"
                    :placeholder=scope.row.remarkMessage style="width: 100%;"></el-input>
                </el-form-item>
                <span v-else>{{'NA'}}</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: left;margin-left: 6%"><span
              class="bold-text">{{'备注:1.客户需要报账合同等及其他报账资料需要单独在邮寄/扫描模块内选择"报账资料"上传附件'}}</span>
            <el-tooltip content="折叠" v-if="showRemark">
              <i class="el-icon-caret-top iconMore" @click="showRemark = !showRemark"></i>
            </el-tooltip>
            <el-tooltip content="展开" v-if="!showRemark">
              <i class="el-icon-caret-bottom iconMore" @click="showRemark = !showRemark"></i>
            </el-tooltip><br>
            <span class="bold-text"
              v-if="showRemark">{{'2.需要注意的是报账合同尽量用实际项目的合同，如果不一致，合同要合法并符合公司规定(公司涉及到的正常项目及公司正常报价范围)'}}</span><br>
            <span class="bold-text" v-if="showRemark">{{'3.尽量不要开试剂票，开了的，公司不提供任何图片和实物。没有按照以上操作的，后果销售自己承担。'}}</span><br>
            <span class="bold-text" v-if="showRemark">{{'4.上传文件可上传多个文件，最大上传数量不能超过5,上传文件总大小不能超过50M。'}}</span>
          </div>
        </div>
        <el-form-item label="销售" prop="applicantId">
          <el-select style="width: 330px;" v-model="form.applicantId" placeholder="请选择销售" filterable>
            <el-option v-for="item in applicantOptions" :key="item.uuid" :label="item.name"
              :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期" prop="applicantDate" label-width="147px">
          <el-input style="width: 330px;" size="small" v-model="form.applicantDate" auto-complete="off"
            placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
        </el-form-item>
        <el-form-item label="收件人:" prop="recipientName"
          :rules="{required: flag, message: '请输入收件人名称', trigger: 'change'}">
          <el-autocomplete class="inline-input" size="small" v-model="form.recipientName"
            :fetch-suggestions="querySearch" placeholder="请输入收件人名称" @select="handleSelect" style="width: 330px;">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="收件人电话" prop="recipientPhone" label-width="147px"
          :rules="{required: flag, message: '请输入收件人电话', trigger: 'change'}">
          <el-input style="width: 330px;" size="small" v-model="form.recipientPhone" placeholder="请输入收件人电话"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" prop="recipientAddress"
          :rules="{required: flag, message: '请输入收件人地址', trigger: 'change'}">
          <el-input style="width: 330px;" size="small" v-model="form.recipientAddress" placeholder="请输入收件地址"></el-input>
        </el-form-item>
        <el-form-item label="邮寄备注:" prop="remark" style="width: 95%!important;">
          <el-input :autosize="{ minRows: 3}" type="textarea" maxlength="300" show-word-limit placeholder="请输入内容"
            v-model="form.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {getPersonById, getPersonByType} from "@/api/dilivery/customer/person";
import {addMail, attachmentMail, editMail} from "@/api/dilivery/mail";
import {getUserById} from "@/api/dilivery/customer/user";
import { checkDate} from "@/utils/rules";
import {padDate} from "@/store/date";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {getAllContract} from "@/api/dilivery/sales/contract";
import SelectRecord from "@/components/reminder/SelectRecord.vue";
import JSZip from 'jszip';
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddEditMail",
  components: { SelectRecord, Loading },
  props:['showDialog','selectType','contractId','selectDetail'],
  data(){
    return{
      showRemark:true,
      loading:false,
      contractLoading:false,
      tableData: [
        {
          id: 1,
          name: '合同',
          mailProp: 'numberOfContract',
          mailMessage: '请选择合同邮寄份数',
          type: 'contract',
          min: 0,
          max: 11,
          scanningProp: 'contractScanningFlag',
          scanningMessage: '请选择是否扫描合同',
          file: '',
          fileName: '',
          fileList: '',
          remark: 'contractExplain',
          remarkMessage: '请填写合同具体邮寄说明'
        },
        // {
        //   id: 2,
        //   name: '发票',
        //   mailProp: 'numberOfInvoice',
        //   mailMessage: '请选择发票邮寄份数',
        //   type: 'invoice',
        //   min: 0,
        //   max: 11,
        //   scanningProp: '',
        //   scanningMessage: '',
        //   file: '',
        //   fileName: '',
        //   fileList: '',
        //   remark: 'invoiceExplain',
        //   remarkMessage: '请填写发票具体邮寄说明'
        // },
        {
          id: 3,
          name: '营业执照',
          mailProp: 'numberOfLicense',
          mailMessage: '请选择营业执照邮寄份数',
          type: 'license',
          min: 0,
          max: 4,
          scanningProp: '',
          scanningMessage: '',
          file: '',
          fileName: '',
          fileList: '',
          remark: 'licenseExplain',
          remarkMessage: '请填写营业执照具体邮寄说明'
        },
        {
          id: 4,
          name: '结题报告',
          mailProp: 'numberOfReport',
          mailMessage: '请选择结题报告邮寄份数',
          type: 'report',
          min: 0,
          max: 6,
          scanningProp: 'reportScanningFlag',
          scanningMessage: '请选择是否扫描结题报告',
          file: 'reportFile',
          fileName: 'reportFileName',
          fileList: 'reportFileList',
          remark: 'reportExplain',
          remarkMessage: '请填写结题报告具体邮寄说明'
        },
        {
          id: 5,
          name: '报账资料',
          mailProp: 'numberOfReimbursementFile',
          mailMessage: '请选择邮寄报账资料份数',
          type: 'reimbursement',
          min: 0,
          max: 6,
          scanningProp: 'reimbursementScanningFlag',
          scanningMessage: '请选择是否扫描报账资料',
          file: 'reimbursementFile',
          fileName: 'reimbursementFileName',
          fileList: 'reimbursementFileList',
          remark: 'reimbursementExplain',
          remarkMessage: '请填写报账资料具体邮寄说明'
        },
        {
          id: 6,
          name: '邮寄资料',
          mailProp: 'numberOfSingleMailFile',
          mailMessage: '请选择邮寄资料份数',
          type: 'mail',
          min: 0,
          max: 6,
          scanningProp: '',
          scanningMessage: '',
          file: 'mailAttachment',
          fileName: 'mailFileName',
          fileList: 'mailFileList',
          remark: 'singleMailFileExplain',
          remarkMessage: '请填写先邮寄资料邮寄说明'
        }
      ],
      numberOption: [
        {label: '否', value: 0},
        {label: '1份', value: 1},
        {label: '2份', value: 2},
        {label: '3份', value: 3},
        {label: '4份', value: 4},
        {label: '5份', value: 5},
        {label: '6份', value: 6},
        {label: '7份', value: 7},
        {label: '8份', value: 8},
        {label: '9份', value: 9},
        {label: '10份', value: 10}
      ],
      flagOption: [
        {label:'是',value:true},
        {label:'否',value:false},
      ],
      mailFileName: '',
      mailFileList: [],
      reportFileName: '',
      reportFileList:[],
      reimbursementFileName: '',
      reimbursementFileList: [],
      title:'',
      role: '',
      userData:{},
      applicantOptions: [],
      ContactOptions: [],
      contractOption: [],
      form:{
        reportFile:[],
        reimbursementFile:[],
        mailingContent: {
          contractExplain: '',
          invoiceExplain: '',
          reportExplain: '',
          licenseExplain: '',
          contractScanningFlag: false,
          reportScanningFlag: false,
          reimbursementScanningFlag: false,
          numberOfContract: 0,//邮寄合同数量
          numberOfInvoice: 0,//邮寄发票数量
          numberOfReport: 0,//邮寄报告数量
          numberOfLicense: 0,//营业执照数量
          numberOfReimbursementFile: 0,//报账资料份数
          numberOfSingleMailFile: 0,
          reimbursementExplain: '',//报账资料说明
          singleMailFileExplain: ''//单独邮寄文件说明
        },
        invoiceId: [],
        contractId: [],
        recipientPhone: '',
        recipientAddress: '',
        appendixExist: true,
        status:'APPLYING',
        mailAttachment: [],
        applicantId: '',
        applicantDate: '',
        recipientName: '',
        remark: ''
      },
      rules: {
        applicantId: [
          {required: true,message: '请选择销售', trigger: 'change'}
        ],
        applicantDate: [
          {required: true, message: '请选择申请日期', trigger: 'change'},
          {validator: checkDate, trigger: 'change'}
        ],
        contractId: [
          {required: true, message: '请选择合同', trigger: 'change'}
        ],
      },
    }
  },
  watch:{
    selectType:{
      handler(newVal){
        if (newVal?.type){
          if(newVal.type==='edit'){
            this.title='编辑邮寄/扫描信息'
          }else{
            this.title='添加邮寄/扫描信息'
          }
        }
      },
      immediate:true
    },
    'form.applicantId': {
      handler(newVal,oldVal){
        if(newVal !== ''){
          this.getContactOptions(newVal)
        }else {
          this.ContactOptions = []
        }
      },
      immediate:true
    },
    selectDetail:{
      async handler(newVal){
        if(newVal&&Object.keys(newVal).length > 0){
          const form = JSON.parse(JSON.stringify(this.form))
          const info = JSON.parse(JSON.stringify(newVal))
          this.form = {
            ...form,
            ...info,
            mailAttachment:[],
            reportFile:[],
            reimbursementFile:[],
          }
          if(newVal.id){
            for(const annex in newVal.mailAttachment){
              if(Object.keys(newVal.mailAttachment[annex]).length>1){
                await this.addFileManually(newVal.id, annex, 'completeAttachments')
              }else if(Object.keys(newVal.mailAttachment[annex]).length === 1){
                await this.addFileManually(newVal.id, annex, '')
              }
            }
          }
        }
      },
      immediate:true
    },
    contractId: {
      handler(newVal){
        if(newVal && newVal.length>0){
          this.form.contractId = newVal.map(item => item.id)
          this.form.applicantId = newVal[0].salesId
          if(this.contractOption.length<=0){
            this.contractOption = [...this.contractOption,...newVal.map(item => {
              return {
                ...item,
                customerCompanyId:item.customerContacts.companyId,
                taxRegistrationNumber:item.customerContacts.taxRegistrationNumber
              }
            })]
          }
        }
      },
      immediate:true
    },
  },
  computed:{
    isRecord(){
      if(this.selectType.type === 'edit'){
        return this.selectDetail?.invoiceId?.length>0
      }else{
        return this.contractOption.filter(item => this.form.contractId.includes(item.id) && item.contractAmount!==item.invoicedAmount).length>0
      }
    },
    flag(){
      const choseFlag = ['numberOfContract','numberOfInvoice','numberOfReport','numberOfLicense','numberOfReimbursementFile','numberOfSingleMailFile']
      for(const key of choseFlag){
        if(this.form.mailingContent[key]){
          return true
        }
      }
      return !(this.form.mailingContent.contractScanningFlag || this.form.mailingContent.reportScanningFlag || this.form.mailingContent.reimbursementScanningFlag);
    },
  },
  mounted() {
    this.remoteMethod();
    this.getApplicantOption();
    if(this.form.applicantDate === ''){
      this.form.applicantDate = this.getCurrentDate()
    }
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
  },
  methods:{
    changeContract(item) {
      if(item.length>0){
        this.form.applicantId = this.contractOption.find(it => it.id === item[0])?.salesId
      }
      this.remoteMethod();
    },
    async addFileManually(id, annexType, name) {
      try {
        // 获取压缩包二进制
        const response = await attachmentMail(id, annexType, name);
        if(!response.file){
          return
        }
        let fileList = []
        if ('application/x-zip-compressed' === response.file.type){
          const zipBlob = new Blob([response.file], { type: response.file.type });
          // 解压缩为文件列表
          fileList = await this.unzipToFileList(zipBlob);
        }else{
          const file = new File([response.file], decodeURI(response.fileName), { type: response.file.type });
          // 创建一个文件对象的包装对象
          const fileWrapper = {
            name: file.name,
            status: 'ready',
            url: '',  
            raw: file, 
          };
          fileList = [fileWrapper]
        }
        switch (annexType) {
          case 'MAIL_ANNEX':
            this.form.mailAttachment = fileList.map(item => item);
            this.mailFileList = fileList.map(item => item);
            break;
          case 'REPORT_ANNEX':
            this.form.reportFile = fileList.map(item => item);
            this.reportFileList = fileList.map(item => item);
            break;
          case 'REIMBURSEMENT_ANNEX':
            this.form.reimbursementFile = fileList.map(item => item);
            this.reimbursementFileList = fileList.map(item => item);
            break;
          default:
            break;
        }
      } catch (error) {
        console.error('解压缩文件失败:', error);
      }
    },
    /**
    * 解压缩 ZIP 文件并返回文件列表
    * @param {Blob} zipBlob - ZIP 文件的 Blob 流
    * @returns {Promise<Array<File>>} - 解压后的文件列表
    */
    async unzipToFileList(zipBlob) {
      const zip = new JSZip();
      const fileList = [];

      // 加载 ZIP 文件
      const zipData = await zip.loadAsync(zipBlob);

      // 遍历 ZIP 文件中的每个文件
      for (const [relativePath, file] of Object.entries(zipData.files)) {
        if (!file.dir) { // 忽略目录
          // 获取文件的 Blob 流
          const fileBlob = await file.async('blob');

          // 将 Blob 转换为 File 对象
          const fileName = relativePath.split('/').pop(); // 获取文件名
          const fileObject = new File([fileBlob], fileName, {
            type: fileBlob.type || 'application/octet-stream',
            lastModified: new Date().getTime(),
          });
          const fileWrapper = {
            name: fileName,
            status: 'ready',
            url: '',
            raw: fileObject,
          };
          fileList.push(fileWrapper);
        }
      }

      return fileList;
    },


    changeMailNumber(value,type) {
      switch (type) {
        case 'invoice':
          if (!this.isRecord && value) {
            this.$messageUi.error('未申请过发票，不能选择邮寄')
            this.form.mailingContent.numberOfInvoice = 0
          }
          break;
        case 'report':
          if(this.form.reportFile.length<=0 && value){
            if(value === true){
              this.$messageUi.error('未上传结题报告，不能选择扫描结题报告')
              this.form.mailingContent.reportScanningFlag = false
            }else{
              this.$messageUi.error('未上传结题报告，不能选择邮寄')
              this.form.mailingContent.numberOfReport = 0
            }
          }
          break;
        case 'reimbursement':
          if (this.form.reimbursementFile.length<=0 && value) {
            if(value === true){
              this.$messageUi.error('未上传报账资料，不能选择扫描报账资料')
              this.form.mailingContent.reimbursementScanningFlag = false
            }else{
              this.$messageUi.error('未上传报账资料，不能选择邮寄')
              this.form.mailingContent.numberOfReimbursementFile = 0
            }
          }
          break;
        case 'mail':
          if (this.form.mailAttachment.length<=0 && value) {
            this.$messageUi.error('未上传单独邮寄附件，不能选择邮寄')
            this.form.mailingContent.numberOfSingleMailFile = 0
          }
          break;
        default:
          break;
      }
    },
    querySearch(queryString, cb) {
      const results = queryString ? this.ContactOptions.filter(item => item.contactName.toLowerCase().includes(queryString.toLowerCase())) : this.ContactOptions;
      const modifiedItems = results.map(item => {
        if (item.contactName) {
          return {
            ...item,
            value: item.contactName,
            contactName: undefined
          };
        }
        return item;
      });
      cb(modifiedItems);
    },
    handleSelect(item) {
      this.form.recipientPhone = item.phone
      this.form.recipientAddress = item.address
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
      const day = date.getDate().toString().padStart(2, '0'); // 日期
      return `${year}-${month}-${day}`
    },
    getContactOptions(uuid) {
      try {
        getUserById(uuid).then(res => {
          if(res.code === 200){
            this.ContactOptions = res.data
          }
        }).catch(err => {})
      } catch (error) {
        console.log(error);
      }
    },
    remoteMethod(query) {
      try {
        this.contractOption = [];
        this.contractLoading = true;
        const type = (this.selectType.type === 'add' && !(this.contractId && this.contractId.length > 0)) ? 'MAILED_CONTRACT' : 'PENDING_MAILED_CONTRACT'
        let data = {}
        if (query) {
          data["query#contractNumber.LIKE"] = query
        }
        const sale = [...new Set(this.contractOption.filter(item => this.form.contractId.includes(item.id)).map(item => { return { salesId: item.salesId, customerContactsId: item.customerContactsId } }))]
        if (sale.length !== 0) {
          data["query#salesId.IN"] = sale.map(item => item.salesId).join(',')
          data["query#customerContactsId.IN"] = sale.map(item => item.customerContactsId).join(',')
        }
        getAllContract(type, data).then(res => {
          if (res.code === 200) {
            this.contractLoading = false;
            this.contractOption = res.data
          }
        })
      } catch (error) {
        console.log(error);
        this.contractOption = [];
        this.contractLoading = false;
      }
    },
    handleExceed(files) {
      this.$messageUi.error('文件上传数量超过5个，请检查'); // 超出数量时提醒
    },
    handleRemove(files,type){
      switch (type){
        case 'report':
          this.form.reportFile.splice(files, 1)
          this.reportFileList.splice(files, 1)
          this.reportFileName = ''
          if(this.reportFileList.length<=0){
            this.form.mailingContent.numberOfReport = 0
            this.form.mailingContent.reportScanningFlag = false
          }
          break
        case 'mail':
          this.form.mailAttachment.splice(files, 1)
          this.mailFileList.splice(files, 1)
          this.mailFileName = ''
          if(this.mailFileList.length<=0){
            this.form.mailingContent.numberOfSingleMailFile = 0
          }
          break
        case 'reimbursement':
          this.form.reimbursementFile.splice(files, 1)
          this.reimbursementFileList.splice(files, 1)
          this.reimbursementFileName = ''
          if(this.reimbursementFileList.length<=0){
            this.form.mailingContent.numberOfReimbursementFile = 0
            this.form.mailingContent.reimbursementScanningFlag = false
          }
          break
        default:
          break
      }
    },
    handleChange(files,type){
      switch (type) {
        case 'report':
          this.form.reportFile = files[1].map(item => item)
          this.reportFileList = files[1].map(item => item)
          if(this.form.mailingContent.numberOfReport === 0){
            this.form.mailingContent.numberOfReport = 1
          }
          break
        case 'mail':
          this.form.mailAttachment = files[1].map(item => item)
          this.mailFileList = files[1].map(item => item)
          if(this.form.mailingContent.numberOfSingleMailFile === 0){
            this.form.mailingContent.numberOfSingleMailFile = 1
          }
          break
        case 'reimbursement':
          this.form.reimbursementFile = files[1].map(item => item)
          this.reimbursementFileList = files[1].map(item => item)
          if(this.form.mailingContent.numberOfReimbursementFile === 0){
            this.form.mailingContent.numberOfReimbursementFile = 1
          }
          break
        default:
          break
      }
    },
    getApplicantOption() {
      try {
        if(['ADMIN', 'MANAGER','SALES_ASSI_MANAGER','SALES_ASSI'].includes(this.role)){
          getPersonByType('SALES', {}).then(res => {
            if (res.code === 200){
              this.applicantOptions = res.data;
            }
          }).catch(err => {})
        }else {
          getPersonById(this.userData['personUuids'][0], {}).then(res => {
            if (res.code === 200){
              this.applicantOptions = res.data;
              this.checkUser();
            }
          }).catch(err => {})
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    checkUser(){
      if(this.applicantOptions.some(item => item.uuid === this.userData['personUuids'][0])){
        if(this.form.applicantId === '' ){
          this.form.applicantId = this.userData['personUuids'][0]
        }
      }
    },
    handle(){
      try{
        this.$refs.form.validate(valid=>{
        if(valid){
          this.loading = true
          this.form.applicantDate = padDate(this.form.applicantDate)
          const formData = new FormData();
          if(!this.isRecord){
            if (this.form.mailAttachment.length>0) {
              for(let file of this.form.mailAttachment){
                formData.append('file', file.raw);
              }
            }
          }else{
            this.form.mailingContent.singleMailFileExplain = ''
          }
          if (this.form.reportFile.length>0) {
            for(let file of this.form.reportFile){
              formData.append('reportFile', file.raw); 
            }
          }
          if(this.form.reimbursementFile.length>0){
            for(let file of this.form.reimbursementFile){
              formData.append('reimbursementFile', file.raw); 
            }
          }
          const jsonStr = JSON.stringify(
              Object.keys(this.form).reduce((acc, key) => {
                if (!['mailAttachment', 'reportFile','reimbursementFile'].includes(key)) {
                  acc[key] = this.form[key];
                }
                return acc;
              }, {})
          );
          const blob = new Blob([jsonStr],{
            type: 'application/json'
          });
          formData.append("info",blob);
          const ApiMethod = this.selectType.type === 'edit'?editMail:addMail
          const successMessage = this.selectType.type === 'edit'?'修改成功':'提交成功'
          ApiMethod(formData).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$emit('submit','confirm')
              this.$messageUi.success(successMessage)
              this.$store.commit('right/setChangeRed',true)
            }
          }).catch(err => {
            this.loading = false
          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
      }catch(err){
        console.log(err);
        this.loading = false
      }
      
    }
  },

}
</script>

<style lang="scss" scoped>
.upload-demo {

  /*margin-top: 20px;*/
  width: 100% !important;
}

:deep(.el-upload) {
  display: flex;
  gap: 20px;
  width: 100% !important;
}

@import "@/assets/css/mixins.scss";

.el-dialog-div {
  @include thin-scrollbar(8px, #888);
  max-height: 60vh;
  /* 你还可以在这个类里写其他样式 */
  background: #fff;
}

.invoice-box {
  border: 1px dashed #ccc; /* 虚线框 */
  padding: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.bold-text {
  font-weight: bold;
  color: red;
  background-color: yellow;
  font-size: 16px;
}

.checkbox-group {
  display: flex;
  flex-wrap: nowrap; /* 禁止换行 */
}

/* 使 <el-row> 的高度贴合内部组件 */
.fit-height-row {
  margin: 0 0 0 0;
  display: flex; /* 使用 flex 布局 */
  align-items: stretch; /* 使子元素的高度自动拉伸 */
  flex-wrap: nowrap; /* 防止换行 */
}

.formDiv {
  display: flex;
  flex-wrap: wrap;
}

.el-form-item {
  width: 45% !important;
}

:deep(.el-select) {
  width: 100%;
}
.el-form-item__label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
}
.no-border-select :deep(.el-input__inner) {
  border: none;
  box-shadow: none;
  background: transparent; /* 背景透明，与表格融合 */
}
.no-border-select :deep(.el-textarea__inner) {
  border: none;
  box-shadow: none;
  background: transparent; /* 背景透明，与表格融合 */
}
</style>
